{
  "MODEL_TOTAL": 195,
  "PROVIDER_TOTAL": 30
}
